const insertRow = ({ object, items }) => [
  {
    ...object,
    serviceUsing: 0,
  },
  ...items
];

export default insertRow;
